import Page from '~/pages/page';

export default class NofoundIndex extends Page {

	constructor(...args) {
		super(...args);

		this._retrieveDOM();
		this._initTls();
	}

	_retrieveDOM() {
		this.dom.views = {};
	}

	bind() {
		super.bind();
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}
